<template>
  <div>
    <v-footer height="auto" class="text-xs-center">
      <v-container>
        <v-layout wrap>
          <v-flex xs12>
            <v-btn v-for="(icon, i) in icons" :key="i" class="mx-3" icon :href="`${icon.link}`" target="_blank">
              <v-icon>{{ icon.image }}</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 mt-2>
            <span class="font-weight-thin">&copy;2019 — Made with Vue.js by Nate</span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
export default {
  data: () => ({
    icons: [
      { image: 'email', link: 'mailto:inventonater@gmail.com' },
      { image: 'fab fa-twitter', link: 'https://twitter.com/inventonater' },
      { image: 'fab fa-linkedin', link: 'https://www.linkedin.com/in/nateaschenbach/' },
      { image: 'fab fa-github', link: 'https://github.com/inventonater' },
      { image: 'fab fa-medium', link: 'https://medium.com/@inventonater' },
      { image: 'fab fa-facebook', link: 'https://www.facebook.com/inventonater' }
    ]
  })
}
</script>